import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as highlightInCorrectWordServices from '@iso/services/listening/highlightInCorrectWord';

//#region CRUD
export function* getHighlightInCorrectWord() {
	yield takeLatest(actions.GET_HIGHLIGHT_INCORRECT_WORD, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(highlightInCorrectWordServices.getHighlightInCorrectWord, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_HIGHLIGHT_INCORRECT_WORD_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* getHighlightInCorrectWordDetail() {
	yield takeLatest(actions.GET_HIGHLIGHT_INCORRECT_WORD_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(highlightInCorrectWordServices.getHighlightInCorrectWordDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_HIGHLIGHT_INCORRECT_WORD_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesHighlightInCorrectWord() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_HIGHLIGHT_INCORRECT_WORD, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(highlightInCorrectWordServices.createQuesHighlightInCorrectWord, body);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* updateHighlightInCorrectWordDetail() {
	yield takeLatest(actions.UPDATE_HIGHLIGHT_INCORRECT_WORD_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(highlightInCorrectWordServices.updateHighlightInCorrectWordDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteHighlightInCorrectWord() {
	yield takeLatest(actions.DELETE_HIGHLIGHT_INCORRECT_WORD, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(highlightInCorrectWordServices.deleteHighlightInCorrectWord, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getHighlightInCorrectWord),
		fork(getHighlightInCorrectWordDetail),
		fork(createQuesHighlightInCorrectWord),
		fork(updateHighlightInCorrectWordDetail),
		fork(deleteHighlightInCorrectWord),
	]);
}
